import React, { Component } from "react";
import {
  BreadcrumbContainer,
  BreadcrumbButton,
  Card as DefaultCard,
  Button,
  Checkbox,
  Update,
  Text,
} from "prospect-path-components";
import styled from "styled-components";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Heading from "../../components/product-management/heading";

import BreadcrumbWrapper from "../../components/product-management/layout/breadcrumb-wrapper";
import HeadingContainer from "../../components/product-management/layout/heading-container";
import PromoteConfirmationModal from "../../components/product-management/overview/promote-confirmation-modal";

import getPromotionMethods from "../../actions/product-management/GetPromotionMethods";
import NotFound from "../not-found";
import { history } from "../../store";
import ErrorText from "../../components/product-management/ErrorText";
import getTeamProduct from "../../actions/product-management/GetTeamProduct";

const Introduction = styled(Text)`
  margin-bottom: 4rem;
`;

const PublishButtonContainer = styled.div`
  display: flex;
  margin-left: auto;
  padding-left: 1rem;
  flex-shrink: 0;
  margin-top: 8rem;
`;

const PublishButton = styled(Button)`
  margin-left: auto;
  flex-shrink: 0;
  height: 3rem;
`;

const Card = styled(DefaultCard)`
  display: flex;
  min-height: 112px;
  margin-right: 2rem;
  flex: 1;

  &:last-child {
    margin-right: 0;
  }
`;

const CardHeading = styled.h3`
  font-size: 1.25rem;
  font-family="Cerebri Sans";
  font-weight: 600;
  margin: 0;
`;

const Row = styled.div`
  display: flex;
  margin-bottom: 2rem;

  ${Card} {
    width: 50%
  }

  @media screen and (max-width: 768px) {
    display: block;

    ${Card} {
      width: 100%
      margin-top: 1rem;
    }
  }
`;

const Icon = styled.svg`
  margin-right: 1rem;
`;

const IconImage = styled.img`
  margin-right: 1rem;
  width: 64px;
  height: 64px;
`;

const CardBody = styled.div`
  width: fill-available;
`;

const CheckboxContainer = styled.span`
  margin-left: auto;
`;

const SuccessText = styled(Text)`
  width: 100%;
  background-color: rgba(180, 248, 0, 0.1);
  color: #369e01;
  padding: 0.375rem 1rem;
  border-radius: 18px;
`;

class Promote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPromotionMethods: [],
      confirmationModalOpen: false,
      promoteSuccess: false,
    };

    this.openConfirmationModal = this.openConfirmationModal.bind(this);
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
    this.promotionMethodIsSelected = this.promotionMethodIsSelected.bind(this);
    this.togglePromotionMethod = this.togglePromotionMethod.bind(this);
    this.getSelectedPromotionMethods =
      this.getSelectedPromotionMethods.bind(this);
    this.getProduct = this.getProduct.bind(this);
    this.getProductId = this.getProductId.bind(this);
    this.getTeamId = this.getTeamId.bind(this);
    this.isReadOnly = this.isReadOnly.bind(this);
    this.getTeam = this.getTeam.bind(this);
  }
  componentWillMount() {
    this.props.getPromotionMethods();
  }
  componentDidMount() {
    const teamId = this.getTeamId();
    const productId = this.getProductId();

    this.props.getTeamProduct(teamId, productId);

    document.title = "Promote | Prospect Path";
  }
  openConfirmationModal() {
    this.setState({ confirmationModalOpen: true });
  }
  closeConfirmationModal(success = false) {
    this.setState({
      confirmationModalOpen: false,
      promoteSuccess: success,
    });
  }
  getTeamId() {
    return parseInt(this.props.currentTeamId);
  }
  isReadOnly() {
    if (this.getTeam() === null || this.getTeam() === undefined) {
      return true;
    }

    return this.getTeam().user_role === "read_only";
  }
  getTeam() {
    return this.props.teams.find((team) => team.id === this.getTeamId());
  }
  promotionMethodIsSelected(promotionMethodId) {
    return this.state.selectedPromotionMethods.includes(promotionMethodId);
  }
  togglePromotionMethod(promotionMethodId) {
    if (this.isReadOnly()) {
      return;
    }

    let { selectedPromotionMethods } = this.state;

    if (this.promotionMethodIsSelected(promotionMethodId)) {
      selectedPromotionMethods = selectedPromotionMethods.filter(
        (id) => id !== promotionMethodId
      );
    } else {
      selectedPromotionMethods.push(promotionMethodId);
    }

    this.setState({ selectedPromotionMethods });
  }
  getSelectedPromotionMethods() {
    return this.props.promotionMethods.filter((promotionMethod) =>
      this.state.selectedPromotionMethods.includes(promotionMethod.id)
    );
  }
  getProductId() {
    return parseInt(this.props.match.params.product_id);
  }
  getProduct() {
    const team = this.props.teams.find(
      (team) => team.id === parseInt(this.props.currentTeamId)
    );

    if (team === undefined) {
      return undefined;
    }

    const product = team.products.find(
      (product) => product.id === parseInt(this.props.match.params.product_id)
    );

    if (product !== undefined) {
      document.title = `${product.name} Promote | Prospect Path`;
    }

    return product;
  }
  productNotAvailableForPromotion() {
    return (
      <div>
        <div className="l-wrapper-content">
          <section className="l-wrapper-container">
            <header className="l-billing-header">
              <div style={{ maxWidth: "60rem" }}>
                {this.state.promoteSuccess ? (
                  <SuccessText>
                    Thank you for submitting your profile update for approval.
                    Once approved your profile will be updated.
                  </SuccessText>
                ) : (
                  ""
                )}
                <HeadingContainer>
                  <Heading>
                    {this.getProduct() ? this.getProduct().name : ""}
                  </Heading>

                  <BreadcrumbWrapper>
                    <BreadcrumbContainer>
                      <BreadcrumbButton
                        onClick={() =>
                          history.push(
                            `/products/${this.props.match.params.product_id}`
                          )
                        }
                      >
                        Overview
                      </BreadcrumbButton>
                      <BreadcrumbButton active>Promote</BreadcrumbButton>
                      {this.props.awardsEnabled && (
                        <BreadcrumbButton
                          onClick={() =>
                            history.push(
                              `/products/${this.props.match.params.product_id}/awards`
                            )
                          }
                        >
                          Awards
                        </BreadcrumbButton>
                      )}
                    </BreadcrumbContainer>
                  </BreadcrumbWrapper>
                </HeadingContainer>
              </div>
            </header>

            <div style={{ maxWidth: "60rem" }}>
              <Text>
                Please Publish your product on the overview page before
                promoting it.
              </Text>
            </div>
          </section>
        </div>
      </div>
    );
  }
  render() {
    if (this.props.user.id === null) {
      window.location = "/signup/product";
    }
    if (
      !this.props.loadingTeams &&
      !this.props.userTeams.includes(parseInt(this.props.currentTeamId))
    ) {
      return <NotFound />;
    }

    const product = this.getProduct();
    if (product === undefined) {
      return "";
    }
    if (product.status !== "pending") {
      return this.productNotAvailableForPromotion();
    }

    const promotionMethods = this.props.promotionMethods
      .filter((promotionMethod) => {
        const primarySoftwareCategoryId = product.primary_software_category_id;
        const additionalSoftwareCategories =
          product.additional_software_categories;
        const currentProductCategoryIds = [primarySoftwareCategoryId].concat(
          additionalSoftwareCategories
        );
        switch (promotionMethod.reference) {
          case "erp_focus":
            const erpCategory = this.props.categories.find(
              (category) => category.slug === "erp"
            );
            if (erpCategory === undefined) {
              return false;
            }
            return currentProductCategoryIds.includes(erpCategory.id);
          case "hrms_world":
            const hrmsCategory = this.props.categories.find(
              (category) => category.slug === "hris"
            );
            if (hrmsCategory === undefined) {
              return false;
            }
            return currentProductCategoryIds.includes(hrmsCategory.id);
          case "ehr_in_practice":
            const ehrCategory = this.props.categories.find(
              (category) => category.slug === "ehr"
            );
            if (ehrCategory === undefined) {
              return false;
            }
            return currentProductCategoryIds.includes(ehrCategory.id);
          case "explore_wms":
            const wmsCategory = this.props.categories.find(
              (category) => category.slug === "wms"
            );
            if (wmsCategory === undefined) {
              return false;
            }
            return currentProductCategoryIds.includes(wmsCategory.id);
          case "discover_crm":
            const crmCategory = this.props.categories.find(
              (category) => category.slug === "crm"
            );
            if (crmCategory === undefined) {
              return false;
            }
            return currentProductCategoryIds.includes(crmCategory.id);
          default:
            return true;
        }
      })
      .map((promotionMethod) => (
        <Card key={promotionMethod.id}>
          <div>
            <IconImage
              alt={`Logo for ${promotionMethod.name}`}
              src={promotionMethod.logo}
            />
          </div>
          <CardBody>
            <div style={{ display: "flex", width: "100%" }}>
              <CardHeading>{promotionMethod.name}</CardHeading>

              <CheckboxContainer
                onClick={() => this.togglePromotionMethod(promotionMethod.id)}
              >
                <Checkbox
                  disabled={this.isReadOnly()}
                  checked={this.promotionMethodIsSelected(promotionMethod.id)}
                />
              </CheckboxContainer>
            </div>

            {promotionMethod.product_distribution_method_type.reference ===
            "api" ? (
              <Update icon highlighted>
                Direct Integration
              </Update>
            ) : (
              <Update>Updated by Email</Update>
            )}
          </CardBody>
        </Card>
      ));

    promotionMethods.push(
      <Card key="suggestions">
        <div>
          <CardBody>
            <CardHeading>Suggest an integration</CardHeading>
          </CardBody>
          <Text>
            Would you like to share your product updates with other comparison
            or review sites? Please email{" "}
            <a href="mailto:customerteam@prospectpath.com">
              customerteam@prospectpath.com
            </a>
            .
          </Text>
        </div>
      </Card>
    );

    // Add rows to promotion methods
    const promotionRows = [];
    for (let i = 0; i < promotionMethods.length; i += 2) {
      promotionRows.push(<Row key={i}>{promotionMethods.slice(i, i + 2)}</Row>);
    }

    return (
      <div>
        <div className="l-wrapper-content">
          <section className="l-wrapper-container">
            <header className="l-billing-header">
              <div style={{ maxWidth: "60rem" }}>
                {this.state.promoteSuccess ? (
                  <SuccessText>
                    Thank you for submitting your profile update for approval.
                    Once approved your profile will be updated.
                  </SuccessText>
                ) : (
                  ""
                )}
                {this.isReadOnly() && (
                  <ErrorText>
                    You do not have permission to promote this product
                  </ErrorText>
                )}
                <HeadingContainer>
                  <Heading>
                    {this.getProduct() ? this.getProduct().name : ""}
                  </Heading>

                  <BreadcrumbWrapper>
                    <BreadcrumbContainer>
                      <BreadcrumbButton
                        onClick={() =>
                          history.push(
                            `/products/${this.props.match.params.product_id}`
                          )
                        }
                      >
                        Overview
                      </BreadcrumbButton>
                      <BreadcrumbButton active>Promote</BreadcrumbButton>
                      {this.props.awardsEnabled && (
                        <BreadcrumbButton
                          onClick={() =>
                            history.push(
                              `/products/${this.props.match.params.product_id}/awards`
                            )
                          }
                        >
                          Awards
                        </BreadcrumbButton>
                      )}
                    </BreadcrumbContainer>
                  </BreadcrumbWrapper>
                </HeadingContainer>
              </div>
            </header>

            <div style={{ maxWidth: "60rem" }}>
              <Introduction>
                The <strong>Promote</strong> page is where you can share your
                updated product information with external websites like
                comparison and review sites. Please select the appropriate
                websites below and click Publish Changes to distribute your
                information.
              </Introduction>

              {promotionRows}

              <PublishButtonContainer>
                <PublishButton
                  color="primary"
                  size="lg"
                  onClick={() => this.openConfirmationModal()}
                  disabled={this.isReadOnly()}
                >
                  Publish Changes
                </PublishButton>
              </PublishButtonContainer>
              <Text style={{ float: "right", width: "20rem" }}>
                Your product information will be shared with the selected sites
                for publication.
              </Text>
            </div>

            <PromoteConfirmationModal
              closeModal={this.closeConfirmationModal}
              shouldFocusAfterRender={false}
              promotionMethods={this.getSelectedPromotionMethods()}
              teamId={this.props.currentTeamId}
              productId={this.props.match.params.product_id}
              isOpen={this.state.confirmationModalOpen}
            />
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  teams: state.teams.all,
  currentTeamId: state.teams.currentTeam,
  userTeams: state.teams.userTeams,
  loadingTeams: state.teams.loadingTeams,
  promotionMethods: state.productManagement.promotionMethods,
  awardsEnabled: state.featureFlags.ProductManagementAwards,
  categories: state.productManagement.categories.all,
});
const mapDispatchToProps = (dispatch) => ({
  getPromotionMethods: () => dispatch(getPromotionMethods()),
  getTeamProduct: (teamId, productId) =>
    dispatch(getTeamProduct(teamId, productId)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Promote)
);
